/** Whether marking a week-off or holiday as worked should offer a Comp Off credit. */
export function compOffGrantOffer({ enabled, applicableDays, isHoliday, isWeekOff }) {
  if (!enabled) return null;
  const applicable = applicableDays || "both";
  let category = null;
  if (applicable === "holidays") category = isHoliday ? "holiday" : null;
  else if (applicable === "weekly_offs") category = isWeekOff ? "weekly_off" : null;
  else if (applicable === "both") {
    if (isHoliday) category = "holiday";
    else if (isWeekOff) category = "weekly_off";
  }
  if (!category) return null;
  return {
    category,
    dayKind: category === "holiday" ? "holiday" : "week off",
  };
}

export function creditDayLabel(value) {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) return "1 day";
  const text = Number.isInteger(amount) ? String(amount) : String(amount);
  return amount === 1 ? "1 day" : `${text} days`;
}

export function compOffGrantMessage(grant, decision, creditLabel = "1 day") {
  if (decision === "skip") return "Comp Off was not added.";
  if (decision !== "allow" || !grant) return "";
  if (grant.outcome === "available") return `${creditLabel} was added to the Comp Off balance.`;
  if (grant.outcome === "duplicate") return "This day is already in the Comp Off balance.";
  if (grant.outcome === "pending_approval") return "Comp Off was sent for approval.";
  if (grant.reason) return `Comp Off was not added. ${grant.reason}`;
  return "Comp Off was not added.";
}
